
import { useQuery } from "@tanstack/react-query";
import * as api from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";

export function useSummary(examSlug: string) {
  return useQuery({
    queryKey: queryKeys.analytics.summary(examSlug),
    queryFn: () => api.getAnalyticsSummary(examSlug),
    enabled: !!examSlug,
  });
}

export function useCategoryStats(examSlug: string) {
  return useQuery({
    queryKey: queryKeys.analytics.categoryStats(examSlug),
    queryFn: () => api.getCategoryStats(examSlug),
    enabled: !!examSlug,
  });
}

export function useWeakQuestions(examSlug: string, limit = 10) {
  return useQuery({
    queryKey: queryKeys.analytics.weakQuestions(examSlug, limit),
    queryFn: () => api.getWeakQuestions(examSlug, limit),
    enabled: !!examSlug,
  });
}

export function useProgress(examSlug: string, days = 30) {
  return useQuery({
    queryKey: queryKeys.analytics.progress(examSlug, days),
    queryFn: () => api.getProgress(examSlug, days),
    enabled: !!examSlug,
  });
}
